import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { DataAnalyticsService } from '../../data-analytics/data-analytics.service';
import { LwProductService } from '../../lw-product/lw-product.service';
import { IconsService } from '../../services/icons.service';
import { DateTime } from 'luxon';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { DemoAccountService } from '../../demo-account.service';
import { time } from '../../services/global-variables.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../common-components/popup/popup.component';
import { Time } from '@angular/common';
import { DataExportService } from '../../services/data-export.service';
import { TimeSelectComponent } from '../../time-select/time-select.component';

@Component({
    selector: 'lds-heating-detail',
    templateUrl: './heating-detail.component.html',
    styleUrls: ['./heating-detail.component.css'],
    standalone: false
})
export class HeatingDetailComponent implements OnInit {
    public motionData;
    public featureSet;
    public features;
    public icon_margin;
    public totalOnData;
    public deviceType;
    public averageTempData;
    public timespan: string;
    public startTime;
    public endTime;
    public room;
    private featuresToShow = ['dimLevel', 'switch', 'movement', 'energy', 'power',
        'temperature', 'targetTemperature', 'buttonPress', 'windowPosition', 'valveLevel'];
    constructor(private route: ActivatedRoute, public icons: IconsService, private demo: DemoAccountService,
        private user: LdsUserService, private dataAnalytics: DataAnalyticsService, private eventBus: LdsEventBusService, private productService: LwProductService, private dataExport: DataExportService, private dialog: MatDialog) { }

    ngOnInit() {
        this.timespan = 'weekly';
        this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
            this.user.currentModule = this.user.temperatureFeatureSets[id].name;
            this.featureSet = this.user.temperatureFeatureSets[id];
            let featuresBuffer = [];
            this.room = this.user.getRoom(this.featureSet);
            if(this.room){
                this.user.currentModule = this.featureSet.name + " - " + this.room.name; 
            }

            this.deviceType = this.productService.setDeviceType(this.featureSet.productCode)
            if (this.featureSet.productCode === 'LW921E') {
                for (const key in this.user.temperatureFeatureSets) {
                    if (this.user.temperatureFeatureSets.hasOwnProperty(key)) {
                        const element = this.user.temperatureFeatureSets[key];
                        if (element.deviceId === this.featureSet.deviceId && element.id !== this.featureSet.id) {
                            for (let index = 0; index < element.features.length; index++) {
                                const e = this.user.features[element.features[index]];
                                if (e.attributes.type === 'temperature') {
                                    featuresBuffer.push(e);
                                }
                            }
                        }
                    }
                }
            }
            for (let index = 0; index < this.featureSet.features.length; index++) {
                const element = this.user.features[this.featureSet.features[index]];
                if (this.featuresToShow.indexOf(element.attributes.type) >= 0) {
                    featuresBuffer.push(element);
                    if (element.attributes.type === 'valveLevel') {
                        this.showTotalOnTime(element);
                    } else if (element.attributes.type === 'temperature') {
                        this.showAverageDailyTemp(element);
                    } else if (element.attributes.type === 'movement') {
                        this.showMotion(element)
                    }
                }
            }
            this.features = featuresBuffer;
        });
    }

    async showMotion(feature) {
        this.dataAnalytics.getFeatureRawData(feature.featureId, null, null, true).subscribe(res => {
            this.motionData = res;
            this.motionData = this.motionData.map(data => {
                const dt = DateTime.fromMillis(data.timestamp);
                data.displayTime = dt.toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)
                return data;
            })
        })
    }

    async showTotalOnTime(feature) {
        if(this.timespan === "custom"){
            this.totalOnData = this.dataAnalytics.getTotalOnTime(feature.featureId, this.timespan, this.startTime, this.endTime, this.dataAnalytics.getDaysBetween(this.startTime, this.endTime));
            return;
        }
        this.totalOnData = this.dataAnalytics.getTotalOnTime(feature.featureId, this.timespan);

    }

    async showAverageDailyTemp(feature) {
        this.averageTempData = this.dataAnalytics.getDailyAverage(feature.featureId);
    }

    changeTimeSpan(value) {
        if (value !== "custom") {
            this.timespan = value;
            for (let index = 0; index < this.featureSet.features.length; index++) {
                const element = this.user.features[this.featureSet.features[index]];
                if (element.attributes.type === 'valveLevel') {
                    this.showTotalOnTime(element);
                }
            }
            return;
        }

        this.dialog.open(TimeSelectComponent).afterClosed().subscribe(res => {
            if(!res.timeSelected){
                return;
            }

            this.timespan = value;

            this.startTime = res.startDate.getTime();
            this.endTime = res.endDate.getTime();
            this.showTotalOnTime(this.findFeature("valveLevel"));
        })
        

    }


    private findFeature(featureType: string) {
        for (let featureIndex in this.features) {
            let feature = this.features[featureIndex];
            if (feature.attributes.type === featureType) {
                return feature;
            }
        }
        return undefined;
    }

    displayProductCode(productCode) {
        return this.icons.getProductCodeDisplay(productCode);
    }


    onExportClick() {
        if (this.timespan === 'weekly') {
            this.exportWeekly();
            return;
        }
        this.exportMonthly();
    }

    exportMonthly() {
        const date = new Date();
        const dateNow = date.getTime();

        const dateMonthAgo = dateNow - time.day * 31;
        this.exportTimeFrame(dateMonthAgo);
    }

    exportTimeFrame(start: number) {
        const temperatureFeature = this.features[0].featureId;
        const targetTemperatureFeature = this.features[1].featureId;
        const valveLevelFeature = this.features[2].featureId;

        const date = new Date();
        const dateNow = date.getTime();

        const temperatureData = this.dataAnalytics.getFeatureRawData(temperatureFeature, start, dateNow);
        const targetTemperatureData = this.dataAnalytics.getFeatureRawData(targetTemperatureFeature, start - time.day, dateNow);
        const valveLevelData = this.dataAnalytics.getFeatureRawData(valveLevelFeature, start - time.day, dateNow);

        let data = [];

        temperatureData.subscribe(result => {
            data = result;
            targetTemperatureData.subscribe(tResult => {
                valveLevelData.subscribe(vResult => {

                    for (let i = 0; i < data.length; i++) {
                        data[i].targetTemperature = tResult[this.getClosestTimeIndex(data[i].timestamp, tResult)].value;
                        data[i].valveLevel = vResult[this.getClosestTimeIndex(data[i].timestamp, vResult)].value;
                    }
                    this.exportData(data);
                });
            });
        });
    }

    exportWeekly() {
        const date = new Date();
        const dateNow = date.getTime();

        const dateWeekAgo = dateNow - time.week;

        this.exportTimeFrame(dateWeekAgo);
    }

    exportData(data) {
        const dialogRef = this.dialog.open(PopupComponent);
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                this.dataExport.exportToCsv("lightwave-data", data, ['Date', 'Temperature', 'Target Temperature', 'Valve Level']);
                return;
            }

            for (let i = 0; i < data.length; i++) {
                const dateString = new Date(data[i].timestamp).toString();
                data[i].timestamp = dateString;
                data[i].value = data[i].value / 10;
                data[i].targetTemperature = data[i].targetTemperature / 10;
                data[i].valveLevel = data[i].valveLevel + "%";
            }
            this.dataExport.exportToCsv("lightwave-data", data, ['Date', 'Temperature', 'Target Temperature', 'Valve Level']);

        });
    }

    private difference(num1: number, num2: number) {
        if (num1 > num2) {
            return num1 - num2;
        }

        if (num2 > num1) {
            return num2 - num1;
        }

        return 0;

    }

    private getClosestTimeIndex(time: number, data) {

        let lowestIndex = -1;

        for (let i = 0; i < data.length; i++) {
            if (data[i].timestamp > time) {
                continue;
            }

            let difference = this.difference(time, data[i].timestamp);

            if (lowestIndex == -1 || data[lowestIndex] > difference) {
                lowestIndex = i;
            }

        }

        return lowestIndex;

    }

}
